<template>
 	<div class="go-style" v-if="total > 0">
		<div class="go-line-sty">
			<!-- <label>跳至</label> -->
		  <el-input-number v-model="currentPage" controls-position="right" :min="1" :max="max" size='mini'></el-input-number>
			<label>页&nbsp;</label>
			<el-button @click="go" class="go-btn" size='mini'>GO</el-button>
		</div>
 	</div>
</template>

<script>
export default {
	name: 'el-go',
	props: {
		pageSize: {
			type: Number,
			default: 10
		},
		total: {
			type: Number,
			default: 0
		}
	},
	data () {
		return {
			currentPage: 1,
			max: 1
		}
	},
	components: {},
	created(){
		this.getMax()
	},
	watch: {
		pageSize: function (v) {
			this.currentPage = 1
			this.getMax()
		},
		total: function(v) {
			this.currentPage = 1
			this.getMax()
		}
	},
	computed: {},
	mounted(){},
	methods: {
		go() {
			this.$emit('current-change', this.currentPage)
		},
		getMax() {
			if (this.total > 0) {
				if (this.total % this.pageSize === 0) {
					this.max = parseInt(this.total/this.pageSize)
				} else {
					this.max = parseInt(this.total/this.pageSize) + 1
				}
			}
		}
	},
	beforeDestroy(){}
}
</script>

<style scoped>
.btns{
	display: flex;
	align-items: center;
}
.go-style {
	/* position: absolute;
  right: 10px;
  top: 32px; */
	display: inline-block;
	color: #666666;
}
.go-line-sty{
	display: inline-block;
	white-space: nowrap;
}
.go-style >>> .el-input-number--mini {
	width: 80px;
	/* margin: 0 10px; */
	margin-right: 5px;
}
.go-style >>> .el-input__inner {
	padding-left: 0;
	padding-right: 30px;
}
.go-btn{

}
</style>



// WEBPACK FOOTER //
// components/go/Go.vue